import { Component, Input, OnInit } from '@angular/core';
import {
  PayrollSummary,
  PayrollSummaryOrderedLists
} from '../../../../services/payroll-summary.service';

@Component({
  selector: 'preview-cash-required',
  templateUrl: './preview-cash-required.component.html',
  standalone: false
})
export class PreviewCashRequiredComponent implements OnInit {
  // @Input() clientCode: string;
  // @Input() configSetupData: PayrollConfigSetupData;
  // @Input() pay: EmployeePay;
  // @Input() payroll: MasterPayrollObject;

  @Input() payrollSummary: PayrollSummary;
  @Input() orderedLists: PayrollSummaryOrderedLists;

  constructor() {}

  get math() {
    return Math;
  }

  ngOnInit(): void {}
}
